import type { Quadrant } from '@/types';
import type { TermKey } from '../themes/index.js';

export function getQuadrant(urgent: boolean, important: boolean): Quadrant {
  if (urgent && important) return 'FIRE';
  if (!urgent && important) return 'STARS';
  if (urgent && !important) return 'WIND';
  return 'MIST';
}

interface QuadrantMeta {
  label: string;
  description: string;
  icon: string;
  colorVar: string;
  bgVar: string;
  borderVar: string;
}

const QUADRANT_META: Record<Quadrant, QuadrantMeta> = {
  FIRE: {
    label: 'Le Brasier',
    description: 'Faire maintenant',
    icon: '🔥',
    colorVar: '--quadrant-fire',
    bgVar: '--quadrant-fire-bg',
    borderVar: '--quadrant-fire-border',
  },
  STARS: {
    label: 'Les Étoiles',
    description: 'Planifier',
    icon: '✦',
    colorVar: '--quadrant-stars',
    bgVar: '--quadrant-stars-bg',
    borderVar: '--quadrant-stars-border',
  },
  WIND: {
    label: 'Le Vent',
    description: 'Déléguer',
    icon: '💨',
    colorVar: '--quadrant-wind',
    bgVar: '--quadrant-wind-bg',
    borderVar: '--quadrant-wind-border',
  },
  MIST: {
    label: 'La Brume',
    description: 'Laisser passer',
    icon: '🌫',
    colorVar: '--quadrant-mist',
    bgVar: '--quadrant-mist-bg',
    borderVar: '--quadrant-mist-border',
  },
};

export function getQuadrantLabel(quadrant: Quadrant): string {
  return QUADRANT_META[quadrant].label;
}

const QUADRANT_TERM_KEYS: Record<Quadrant, TermKey> = {
  FIRE: 'quadrantFireLabel',
  STARS: 'quadrantStarsLabel',
  WIND: 'quadrantWindLabel',
  MIST: 'quadrantMistLabel',
};

/** Clé de lexique du libellé thémable d'un quadrant — préférer à `getQuadrantLabel` (figé sur "oracle") dans l'UI. */
export function getQuadrantTermKey(quadrant: Quadrant): TermKey {
  return QUADRANT_TERM_KEYS[quadrant];
}

export function getQuadrantDescription(quadrant: Quadrant): string {
  return QUADRANT_META[quadrant].description;
}

export function getQuadrantIcon(quadrant: Quadrant): string {
  return QUADRANT_META[quadrant].icon;
}

export function getQuadrantColorVar(quadrant: Quadrant): string {
  return QUADRANT_META[quadrant].colorVar;
}

export function getQuadrantBgVar(quadrant: Quadrant): string {
  return QUADRANT_META[quadrant].bgVar;
}

export function getQuadrantBorderVar(quadrant: Quadrant): string {
  return QUADRANT_META[quadrant].borderVar;
}

export function getQuadrantMeta(quadrant: Quadrant): QuadrantMeta {
  return QUADRANT_META[quadrant];
}
